// HA reports light brightness on a 0-255 scale and nothing else — there is no
// brightness_pct attribute. Everything else in this app (sliders, the saved
// brightness helper, light_brightness_min/max) is a percentage, so convert at
// the boundary and nowhere else.

export function brightness255ToPercent(
  raw: number | string | undefined | null,
): number | undefined {
  if (raw === undefined || raw === null || raw === '') return undefined;
  const n = Number(raw);
  if (!Number.isFinite(n)) return undefined;
  return Math.round((n * 100) / 255);
}

export function percentToBrightness255(pct: number): number {
  return Math.round((pct * 255) / 100);
}
